// extracted by mini-css-extract-plugin
var _1 = "video-player";
var _2 = "video-wrapper";
export { _1 as "video-player", _2 as "video-wrapper" }
